import React from "react";
import { styleEnd, styleStart } from "../../../algorithms/styleDirection";
import { formatDatelll } from "../../../algorithms";
import { paths } from "../../../paths/paths";

export default function CommentCard({ procedure, createDate }) {
  let userPhoto;
  if (procedure?.memberPhoto != null)
    userPhoto = `url("${paths.MemberPhoto}${procedure.memberId}/${procedure.memberPhoto}")`;
  else userPhoto = `url("/assets/images/userPlaceholder.png")`;
  return (
    <>
      <div className="d-flex flex-md-row flex-column px-4 align-items-center">
        <div className="d-flex align-items-center justify-content-md-start justify-content-center my-2 col-12 col-md-7">
          <div
            style={{
              backgroundImage: userPhoto,
              width: 40,
              height: 40,
              borderRadius: "50%",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              border: "1px solid white",
            }}
          />

          <p className="mx-2 my-0 fw-bold">{procedure.memberName}</p>
        </div>

        <div className="col-12 col-md-4 col-xl-5 d-flex px-xl-4 my-2 justify-content-md-end justify-content-center">
          <span
            className={`text-muted ${styleStart(
              "m",
              0,
            )} ${styleEnd("m", 4, "md")}`}
            style={{ fontSize: 14 }}
          >
            {formatDatelll(createDate)}
          </span>
        </div>
      </div>

      <div
        className="d-flex px-md-5 mx-4 align-items-center"
        style={{
          textAlign: "justify",
          fontSize: 16,
          color: "#444444",
        }}
      >
        <p>{procedure.description}</p>
      </div>
    </>
  );
}
